import React, { useEffect, useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import Aos from "aos";
import "aos/dist/aos.css";

// Import images
import img1 from './ADSecurity.svg';
import img2 from './ExternalAttack.svg';
import img3 from './Operation.svg';
import img4 from './cloudSecurity.svg';
import img5 from './vulnerablity.svg';

// Import the new accordion component (rename your Accorion.js to TenableAccordion.js)
import { TenableAccordion } from './TenableAccordion'; 

// Consolidate data with unique keys for tabs
const tenableSolutions = [
  {
    key: "vuln-mgmt",
    image: img5,
    title: "Vulnerability Management",
    heading: 'Take a Risk-based Approach to Addressing Exposures',
    description: `Legacy vulnerability management tools are no match for today’s complex IT landscape. Risk-based vulnerability management takes the guesswork out of which vulnerabilities you should tackle first. Gain clear answers so you can avoid wading through a never-ending vulnerability backlog.`,
  },
  {
    key: "easm",
    image: img2,
    title: "External Attack Surface Management",
    heading: 'Discover and Secure Your Entire External Attack Surface',
    description: `Visibility is foundational to cybersecurity, yet few organizations have mastered it. External attack surface management (EASM) maps the entire internet and discovers all of your organization’s domains. Identify and secure previously unknown internet-connected assets to eliminate blind spots.`,
  },
  {
    key: "ad-security",
    image: img1,
    title: "Active Directory Security",
    heading: 'Secure Active Directory and Prevent Attack Paths',
    description: `Behind almost every breach headline is an attack on Active Directory (AD) that allows the attacker to elevate privileges and facilitate lateral movement. Tenable enables you to see everything in your complex Active Directory environment, predict what matters and address risks to prevent attack paths before attackers can exploit them.`,
  },
  {
    key: "ot-security",
    image: img3,
    title: "Operational Technology Security",
    heading: 'Industrial Control Systems (ICS) Require Industrial Grade Security',
    description: `Industrial enterprises are preparing for the future, integrating OT and IT more than ever before. Industrial digital transformation increases control, efficiencies, production and safety, but it’s not without risks. Tenable offers complete visibility, unified security and prioritization of threat management to help mitigate risk.`,
  },
  {
    key: "cloud-security",
    image: img4,
    title: "Cloud Security",
    heading: 'Unified Cloud Native Application Protection Platform (CNAPP)',
    description: `Rapid cloud adoption has given rise to complex, multi-cloud environments. With Tenable Cloud Security you can easily ramp up security across all your multi-cloud environments. From full asset discovery and deep risk analysis to runtime threat detection and compliance, you can reduce complexity, minimize your cloud exposure and enforce least privilege at scale.`,
  },
];

export const Products = () => {
  const [activeKey, setActiveKey] = useState('vuln-mgmt');
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 768);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="tenable-solutions-section">
      <div className="tenable-solutions-container">
        <h2 className="tenable-section-title" data-aos="fade-up">
          Featured Solutions
        </h2>
        
        {isWideScreen ? (
          // --- DESKTOP VIEW (TABS) ---
          <div className="tenable-tabs-container" data-aos="fade-up" data-aos-delay="200">
            <Tab.Container id="tenable-solutions-tabs" activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
              <div className="tenable-tabs-layout">
                {/* Left Side: Navigation Pills */}
                <Nav variant="pills" className="flex-column tenable-nav-pills">
                  {tenableSolutions.map(({ key, image, title }) => (
                    <Nav.Item key={key}>
                      <Nav.Link eventKey={key} className="tenable-nav-link">
                        <img src={image} alt="" className="tenable-nav-icon" />
                        <span className="tenable-nav-text">{title}</span>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                {/* Right Side: Content */}
                <Tab.Content className="tenable-tab-content">
                  {tenableSolutions.map(({ key, heading, description }) => (
                    <Tab.Pane eventKey={key} key={key} className="tenable-tab-pane fade-in">
                      <h3 className="tenable-content-heading">{heading}</h3>
                      <p className="tenable-content-description">{description}</p>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        ) : (
          // --- MOBILE VIEW (ACCORDION) ---
          <div className="tenable-mobile-accordion-container" data-aos="fade-up">
            {tenableSolutions.map((solution, index) => (
              // Using the new TenableAccordion component
              <TenableAccordion key={index} {...solution} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};